import type { CustomIconProps } from '../../types/icon';

const AgentIcon = ({ size = '1em', ...otherProps }: CustomIconProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
    >
        <title>Agent Icon</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7277 10.9149C16.5669 11.3949 16.5669 12.6051 15.7277 13.0851L4.12056 19.7232C3.28724 20.1997 2.25 19.5981 2.25 18.6381L2.25 5.36196C2.25 4.40198 3.28723 3.8003 4.12056 4.27687L12.308 8.95926C12.6676 9.16489 12.7924 9.62308 12.5868 9.98265C12.3811 10.3422 11.9229 10.467 11.5634 10.2614L3.75 5.79293L3.75 18.2071L14.6035 12L13.9934 11.6511C13.6338 11.4454 13.509 10.9872 13.7147 10.6277C13.9203 10.2681 14.3785 10.1433 14.738 10.349L15.7277 10.9149Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.39645 12L10.0066 12.349C10.3662 12.5546 10.491 13.0128 10.2853 13.3724C10.0797 13.7319 9.62151 13.8567 9.26195 13.6511L8.27232 13.0851C7.43306 12.6051 7.43306 11.3949 8.27232 10.9149L19.8794 4.27687C20.7128 3.8003 21.75 4.40198 21.75 5.36196V18.6381C21.75 19.5981 20.7128 20.1997 19.8794 19.7232L11.7019 15.0465C11.3423 14.8408 11.2176 14.3827 11.4232 14.0231C11.6288 13.6635 12.087 13.5387 12.4466 13.7444L20.25 18.2071V5.79293L9.39645 12Z"
            fill="currentColor"
        />
    </svg>
);

export default AgentIcon;
